export default class CalibrationModalController {
  /* @ngInject*/
  constructor($scope, $rootScope, $timeout, $localStorage, $uibModalInstance, Modal, appConfig) {
    // Assign injected values to scope
    let $ctrl = this;
    $ctrl.Modal = Modal;
    $ctrl.$uibModalInstance = $uibModalInstance;
    $ctrl.appConfig = appConfig;
    $ctrl.$scope = $scope;
    $ctrl.$rootScope = $rootScope;
    $ctrl.$timeout = $timeout;
    $ctrl.$localStorage = $localStorage;
    $ctrl.canCancelCalibration = false;
    $ctrl.ccSize = 175;
    $ctrl.ccRatio = 1.585772508336421;
    $ctrl.ccBase = 100;
    $ctrl.screenSize = 0;

    $ctrl.screen = {
      width: window.screen.width,
      height: window.screen.height
    };

    this.sliderOpts = {
      floor: -30,
      ceil: 320, //defaults to rz-slider-model
      step: 1,
      precision: 2,
      minLimit: null,
      maxLimit: null,
      minRange: null,
      maxRange: null,
      pushRange: false,
      id: null,
      translate: null,
      getLegend: null,
      stepsArray: null,
      bindIndexForStepsArray: false,
      draggableRange: false,
      draggableRangeOnly: false,
      showSelectionBar: false,
      showSelectionBarEnd: false,
      showSelectionBarFromValue: null,
      hidePointerLabels: true,
      hideLimitLabels: true,
      autoHideLimitLabels: true,
      readOnly: false,
      disabled: false,
      interval: 350,
      showTicks: false,
      showTicksValues: false,
      ticksArray: null,
      ticksTooltip: null,
      ticksValuesTooltip: null,
      vertical: false,
      getSelectionBarColor: null,
      getTickColor: null,
      getPointerColor: null,
      keyboardSupport: true,
      scale: 1,
      enforceStep: true,
      enforceRange: false,
      noSwitching: false,
      onlyBindHandles: false,
      onStart: null,
      onChange: () => {
        $ctrl.updateSize();
      },
      onEnd: null,
      rightToLeft: false,
      boundPointerLabels: false,
      mergeRangeLabelsIfSame: false,
      customTemplateScope: null,
      logScale: false,
      customValueToPosition: null,
      customPositionToValue: null,
      selectionBarGradient: null,
      ariaLabel: null,
      ariaLabelledBy: null,
      ariaLabelHigh: null,
      ariaLabelledByHigh: null
    };
    if($localStorage.hasOwnProperty('screen')) {
      $ctrl.canCancelCalibration = true;
    }
    $ctrl.updateSize();
    $ctrl.wizardStepActive = 0;
    $ctrl.wizardStepTotal = 1;

    $uibModalInstance.rendered.then(() => {
      this.wizardStepTotal = $('.wizard-steps').length;
    });
  }

  tutorialPrev() {
    this.wizardStepActive--;
  }

  tutorialNext() {
    this.wizardStepActive++;
    this.$timeout(() => {
      this.$scope.$broadcast('rzSliderForceRender');
    });
  }

  tutorialFinish() {
    // Finish off tutorial, store data in localStorage, set calibration time cookie
    let $ctrl = this;
    $ctrl.screen.calibratedAt = new Date().getTime();
    $ctrl.$localStorage.screen = $ctrl.screen;
    $ctrl.$localStorage.calibrated = true;
    $ctrl.$rootScope.$broadcast('ts:screenCalibrated');
    $ctrl.closeModal();
  }

  updateSize() {
    let $ctrl = this;
    $ctrl.screen = {
      width: window.screen.width,
      height: window.screen.height
    };

    $ctrl.ccWidth = ($ctrl.ccBase * $ctrl.ccRatio) + ($ctrl.ccSize * $ctrl.ccRatio);
    $ctrl.ccHeight = $ctrl.ccBase + $ctrl.ccSize;
    let pixelHypotenuse = Math.sqrt(Math.pow($ctrl.screen.width, 2) + Math.pow($ctrl.screen.height, 2));
    $ctrl.rPixel = $ctrl.ccWidth / 85.6;
    let screenHypotenuse = pixelHypotenuse / $ctrl.rPixel;
    $ctrl.screenSize = screenHypotenuse / 25.4;
    // Well leave the actual width and height in mm.
    $ctrl.screen.hypotenuse = pixelHypotenuse;
    $ctrl.screen.rPixel = $ctrl.rPixel;
    $ctrl.screen.actualHypotenuse = screenHypotenuse;
    $ctrl.screen.actualWidth = $ctrl.screen.width / $ctrl.rPixel;
    $ctrl.screen.actualHeight = $ctrl.screen.height / $ctrl.rPixel;
  }

  cancelCalibration() {
    this.$uibModalInstance.dismiss();
  }

  closeModal() {
    this.$uibModalInstance.close();
  }

}



// WEBPACK FOOTER //
// ./client/components/modal/calibration/modal.component.js